/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftDownIcon20Regular = forwardRef('ArrowDUturnLeftDownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4.25 9a6.75 6.75 0 1 1 13.5 0v4.25a.75.75 0 0 1-1.5 0V9a5.25 5.25 0 1 0-10.5 0v5.96l2.929-3.446a.75.75 0 0 1 1.142.972l-3.297 3.88a2 2 0 0 1-3.048 0L.18 12.485a.75.75 0 1 1 1.142-.972L4.25 14.96V9Z" })));
});
